import React from 'react'
import { Box, Divider, Typography } from '@mui/material'
import { rbacDetailsCardSx, rbacDetailsCardHeaderSx } from './constants/rbacDetailCardConstants'
import { rbacDetailsDividerSx } from '../pages/shared/rbacUserDetailConstants'

export default function RbacDetailSection({ title, icon, children, contentSx = {} }) {
  return (
    <Box sx={rbacDetailsCardSx}>
      <Box sx={rbacDetailsCardHeaderSx}>
        {icon}
        <Typography
          sx={{ fontSize: 15, fontWeight: 700, lineHeight: 1.2, textTransform: 'uppercase' }}
        >
          {title}
        </Typography>
      </Box>
      <Divider sx={rbacDetailsDividerSx} />
      <Box sx={contentSx}>{children}</Box>
    </Box>
  )
}
